import { render, staticRenderFns } from "./Sensordaten.vue?vue&type=template&id=79e278f6&scoped=true"
import script from "./Sensordaten.vue?vue&type=script&lang=js"
export * from "./Sensordaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e278f6",
  null
  
)

export default component.exports